import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {FormattedDate} from 'react-intl';
import ModalConfirm from '../ModalConfirm'
import {copiaTestoNegliAppunti} from '../../Helpers';
import {client} from '../../Client';

class DocumentiTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onCopyToClipboard(value){
        copiaTestoNegliAppunti(value);
    }

    render() {
        let c = this.props.item

        let linkCommessa = null;
        if (c.idCommessa !== null && c.idCommessa.idCommessa !== undefined){
            linkCommessa = (
                <Link title="Vai alla commessa associata" to={"/app/commesse/edit/" + c.idCommessa.idCommessa} >{c.idCommessa.nomeCompleto}</Link>
            );
        }
        let linkGara = null;
        if (c.idGara !== null && c.idGara.idGara !== undefined){
            linkGara = (
                <Link title="Vai alla gara associata" to={"/app/gare/edit/" + c.idGara.idGara} >{c.idGara.nomeCompleto}</Link>
            );
        }
        let copyBtn = null;
        if (c.clientFullname){
            copyBtn = <a className="ui blue icon button" onClick={() => this.onCopyToClipboard(client.adaptClientPath(c.clientFullname))} title="Copia il path locale del documento sugli appunti"><i
                className="copy icon"
            ></i></a>
        }
        else {
            copyBtn = <a className="ui gray icon button disabled"  title="Path locale non impostato"><i
                className="copy icon"
            ></i></a>
        }
        let deleteBtn = null;
        if(this.props.readOnly == false){
            deleteBtn = (
                    <ModalConfirm
                        msg={"Stai per cancellare il documento: " + this.props.item.nome}
                        onClickOk={(ev) => (this.props.onDelete(ev, c))}
                    >
                        <a className="ui red icon button"><i className="trash icon"/></a>
                    </ModalConfirm>
            );
        }

        return (
            <tr>
                <td className="collapsing">{c.idDocumento}</td>
                <td className="sorted descending">{c.nome}
                </td>
                <td className="collapsing center aligned">{c.anno}
                </td>
                <td className="collapsing center aligned">{c.progressivo}
                </td>
                <td className="">
                    {linkCommessa}
                    {linkGara}
                </td>
                <td className="">
                    {c.idDivisione ? c.idDivisione.nome : ''}
                </td>
                <td className="sorted descending">
                    {c.codiceTipoDocumento.nome} ({c.codiceTipoDocumento.codiceTipoDocumento})
                </td>
                <td className="collapsing center aligned">
                    {c.creatoIl != null ?
                    <FormattedDate
                    value={c.creatoIl}
                    day="numeric"
                    month="numeric"
                    year="numeric"
                /> : <span></span>
                    }
                </td>
                <td className="collapsing no-print">
                    {copyBtn}
                    <a className="ui blue icon button" onClick={(ev) => (this.props.onDownload(ev, c))}><i
                        className="download icon"

                    ></i></a>
                    {deleteBtn}
                </td>
            </tr>)
    }
}

export default DocumentiTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/documenti/DocumentiTableRow.js
 **/